<template>
  <div>
    <v-app>
      <v-img src="" class="background-display">
      <v-container>
      <v-card width="400" class="mx-auto mt-5">
        <v-snackbar v-model="snackbar" top :timeout="6000">
          <span>Se le ha enviado a su correo un código para confirmar su registro de usuario</span>
        </v-snackbar>
        <v-toolbar dark color="#00b2bb">
          <v-card-title>
            <span class="headline font-weight-thin">Confirmar Registro</span>
          </v-card-title>
        </v-toolbar>
          <v-progress-linear v-if="apiRequest"
          indeterminate
          color="teal" dark
          ></v-progress-linear>
        <v-card-text>
          <v-alert v-model="alert" border="left" close-text="Close Alert" dismissible dense outlined type="error">
            Error! Código errado.
          </v-alert>
          <v-alert v-model="alertResend" border="left" close-text="Close Alert" dismissible dense outlined type="error">
            Error! El correo usado ya estaba confirmado.
          </v-alert>
          <v-alert v-model="alertResendEmail" border="left" close-text="Close Alert" dismissible dense outlined type="error">
            Error! Debe colocar un correo para poder reenviarle el código.
          </v-alert>
          <v-alert v-model="alertResendEmailNotExist" border="left" close-text="Close Alert" dismissible dense outlined type="error">
            Error! Correo no registrado.
          </v-alert>
          <v-alert v-model="alertResendLimited" border="left" close-text="Close Alert" dismissible dense outlined type="error">
            Error! Ha excedido la cantidad de intentos, por favor intente más tarde.
          </v-alert>
          <v-form ref="form">
             <EmailField
                v-model="email"
                :name="email"
                :schema="{
                  label: 'Correo',
                  icon: 'mdi-email'
                }"
                solo
              >
              </EmailField>
              <StringField
                v-model="confirmCode"
                :name="confirmCode"
                :schema="{
                   label: 'Código Confirmación',
                   icon:'mdi-account'
                 }"
               >
               </StringField>
          </v-form>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="mx-2">
          <v-btn color="normal" :to="'/'">Cancelar</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="#00b2bb" dark v-if="!alert" @click="validationRules">Enviar</v-btn>
        </v-card-actions>
      <v-card-text class="ml-10 mt-5">No ha recibido el código? <a  @click="resendConfirmationCode">Reenviar código</a></v-card-text>
      </v-card>
      </v-container>
      </v-img>
    </v-app>
  </div>
</template>
<style>
.title-size {
  font-size: 1.25em;
}
.background-display {
  background-color: #f5f5f5 !important;
  width: auto;
  min-height: 100%;
}
</style>
<script>
/* import { Auth } from 'aws-amplify' */
import { Auth } from '@aws-amplify/auth'
import EmailField from '../../components/fields/email/Field.vue'
import StringField from '../../components/fields/string/Field.vue'
// @ is an alias to /src
export default {
  name: 'ConfirmSignUp',
  components: {
    EmailField,
    StringField
  },
  data: () => ({
    showPassword: false,
    alert: false,
    alertResend: false,
    alertResendEmail: false,
    alertResendEmailNotExist: false,
    alertResendLimited: false,
    /* email: this.$router.query.email, */ /* Asi se recibe el valor de la otra pag  store.state.user.attributes.email */
    email: '',
    confirmCode: '',
    apiRequest: false,
    snackbar: false
  }),
  mounted () {
    const usuario = JSON.parse(localStorage.getItem('nuevo_usuario'))
    if (usuario) {
      this.email = usuario.email
    }
    this.snackbar = true
  },
  /* Metodo para saber si el usuario esta logeado */
  methods: {
    async confirmSignup () {
      this.apiRequest = true
      try {
        await Auth.confirmSignUp(this.email, this.confirmCode, { forceAliasCreation: true })
        this.apiRequest = false
        localStorage.removeItem('nuevo_usuario')
        this.$router.push({ path: '/signupmessage' })
      } catch (error) {
        this.alert = true
        this.apiRequest = false
        console.log(error)
      }
    },
    validationRules () {
      if (this.$refs.form.validate()) {
        this.confirmSignup()
      }
    },
    async resendConfirmationCode () {
      try {
        await Auth.resendSignUp(this.email)
        this.snackbar = true
        console.log('code resent successfully')
      } catch (err) {
        if (err.message === 'User is already confirmed.') {
          this.alertResend = true
        } else if (err.message === 'Username/client id combination not found.') {
          this.alertResendEmailNotExist = true
        } else if (err.message === 'Attempt limit exceeded, please try after some time.') {
          this.alertResendLimited = true
        } else {
          this.alertResendEmail = true
        }
        console.log(err)
      }
    }
  }
}
</script>
